import * as React from 'react';
import { spinnerDefaultProps } from './props';
import * as S from './styles';
const SPINNER_ACESSIBILITY_ERROR = 'É necessário informar o atributo "aria-label" para garantir acessibilidade para leitores de tela.';
const SPINNER_COORDINATES = 44;
const SPINNER_STROKE = 3.52;
const SPINNER_RADIUS = 22 - SPINNER_STROKE / 2;
const SPINNER_VIEW_BOX = '22 22 44 44';
export const Spinner = ({ 'aria-label': ariaLabel, color = spinnerDefaultProps.color, inverted, size, className, }) => {
    if (ariaLabel === undefined || ariaLabel === '')
        throw new Error(SPINNER_ACESSIBILITY_ERROR);
    return (React.createElement(S.CircleSpinningContainer, { "data-ds-component": "DS-Spinner", className: className, "aria-label": ariaLabel, size: size, color: inverted === true ? '--color-neutral-70' : color || spinnerDefaultProps.color },
        React.createElement("svg", { "aria-hidden": "true", fill: "currentColor", viewBox: SPINNER_VIEW_BOX },
            React.createElement(S.AnimatedStrokeCircle, { fill: "none", cx: SPINNER_COORDINATES, cy: SPINNER_COORDINATES, r: SPINNER_RADIUS, strokeWidth: SPINNER_STROKE }))));
};
